export default __webpack_public_path__ + "static/media/AdCave_06.7765de6b.png";